import React, { useEffect } from 'react';

import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import { format, parse, subDays } from 'date-fns';
import useBookingData from '../../state/booking/hooks/useProducer';

function RoomDateChanger({ close, show }) {
  const { booking, change } = useBookingData();
  const { handleSubmit, setValue, register, reset } = useForm();
  const [selectedCheckIn, setSelectedCheckIn] = React.useState(new Date());
  const [selectedCheckOut, setSelectedCheckOut] = React.useState(new Date());

  const onSubmit = (data) => {
    const bookingData = {
      ...data,
      check_in: format(selectedCheckIn, 'MM/dd/yyyy'),
      check_out: format(selectedCheckOut, 'MM/dd/yyyy'),
    };
    change(bookingData);
    close();
  };

  useEffect(() => {
    setValue('check_in', new Date());
    setValue('check_out', new Date());
    if (booking.check_in && booking.check_out) {
      setSelectedCheckIn(parse(booking.check_in, 'MM/dd/yyyy', new Date()));
      setSelectedCheckOut(parse(booking.check_out, 'MM/dd/yyyy', new Date()));
      reset(booking);
    }
  }, []);

  return (
    <Modal show={show} onHide={() => close()} backdrop="static" keyboard={false} size="lg">
      <Modal.Header closeButton className="bg-dark" closeVariant="white">
        <Modal.Title>Change Booking Date</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col>
              <Form.Label htmlFor="checkIn">Check In</Form.Label>
              <DatePicker
                placeholderText="Check in"
                minDate={new Date()}
                endDate={selectedCheckOut}
                selectsStart
                selected={selectedCheckIn}
                onChange={(value) => {
                  setValue('check_in', value, {
                    shouldValidate: true,
                    shouldDirty: true,
                  });
                  setSelectedCheckIn(value);
                }}
                dateFormat="MM/dd/yyyy"
                className="form-control"
              />
            </Col>
            <Col>
              <Col>
                <Form.Label htmlFor="checkOut">Check Out</Form.Label>
                <DatePicker
                  placeholderText="Check out"
                  minDate={selectedCheckIn || subDays(selectedCheckIn, -1)}
                  startDate={selectedCheckIn}
                  selected={selectedCheckOut}
                  selectsEnd
                  onChange={(value) => {
                    setValue('check_out', value, {
                      shouldValidate: true,
                      shouldDirty: true,
                    });
                    setSelectedCheckOut(value);
                  }}
                  dateFormat="MM/dd/yyyy"
                  className="form-control"
                />
              </Col>
            </Col>
            <Col>
              <Form.Label>Room</Form.Label>
              <Form.Select {...register('rooms')}>
                {Array(9)
                  .fill(1)
                  .map((el, i) => (
                    <option key={Math.random()} value={i + 1}>
                      {i + 1}
                    </option>
                  ))}
              </Form.Select>
            </Col>
            <Col>
              <Form.Label>Adults</Form.Label>
              <Form.Select {...register('adults')}>
                {Array(4)
                  .fill(1)
                  .map((el, i) => (
                    <option key={Math.random()} value={i + 1}>
                      {i + 1}
                    </option>
                  ))}
              </Form.Select>
            </Col>
            <Col>
              <Form.Label>Children</Form.Label>
              <Form.Select {...register('children')}>
                {Array(5)
                  .fill(1)
                  .map((el, i) => (
                    <option key={Math.random()} value={i}>
                      {i}
                    </option>
                  ))}
              </Form.Select>
            </Col>
          </Row>
          <Row>
            <Col className="d-flex justify-content-end mt-4">
              <Button variant="secondary" onClick={() => close()} className="mx-2">
                Close
              </Button>
              <Button variant="primary" type="submit" className="btn-select">
                Check Availability
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default RoomDateChanger;
